import React from 'react';
import PropTypes from 'prop-types';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMConst from 'lib/SMConst';
import SMAppHelper from 'components/helpers/SMAppHelper';
import update from 'react-addons-update';
import SMUserResource from 'resources/SMUserResource';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMUFavoriteListSelectView extends SMDashboardBaseView {

  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      room: {},
      listItems: [],
      display: "",
      isFavoriteListCreateViewOpen: false,
      errorText: ""
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen === true && prevProps.isOpen === false) {
      SMAppHelper.canBodyScroll(false);
      $(this.refs.modal).niftyModal({
        afterClose: (modal, e)=>{
          this.dismiss();
          e.preventDefault();
          SMAppHelper.canBodyScroll(true);
        }
      });

      let responseHandler = (data, error, xhr) => {
        $(this.refs.mainCol).stopLoading();
        this.setState({display: SMConst.Display.Visible});
        if (error) {
          return;
        } else {
          // もしお気に入りリストが存在しない場合はリスト作成のフォームをポップアップ表示時に表示させておく
          if (data.length === 0) {
            this.setState({
              isFavoriteListCreateViewOpen: true,
              isSMUFavoriteListSelectViewOpen: true,
            });
          }
          this.setState({
            listItems: data,
            isSMUFavoriteListSelectViewOpen: true,
          });
        }
      };
      this.setState({display: SMConst.Display.Loading});
      $(this.refs.mainCol).startLoading();
      SMUserResource.getFavoriteLists(this.props.user.username, responseHandler);
    }
  }

  componentDidMount() {
    this.applyResponsive();
  }

  dismiss(e) {
    $(this.refs.modal).find(".md-close").click();
    if (e) {
      e.preventDefault();
    } else {
      if(this.props.delegate && typeof this.props.delegate.favoriteListSelectViewDidClose === 'function'){
        this.props.delegate.favoriteListSelectViewDidClose();
      }
    }
  }

  showFormView() {
    this.setState({isFavoriteListCreateViewOpen: true});
  }

  closeFormView() {
    this.setState({isFavoriteListCreateViewOpen: false});
  }

  favoriteListImageDidSelect(favoriteList, room){
    if (room.registered_favorite_lists.indexOf(favoriteList.id) >= 0) {
      // お気に入り削除の場合
      this.removeFavorite(favoriteList, room);
    } else {
      // お気に入り登録の場合
      this.addFavorite(favoriteList, room);
    }
  }

  formDidSubmit(e) {
    e.preventDefault();
    let favoriteListName = this.refs.favoriteListName.value;
    let responseHandler = (data, error, xhr) => {
      if (error) {
        if (xhr.responseJSON.message) {
          this.setState({errorText: xhr.responseJSON.message,});
        } else {
          this.setState({errorText: I18n.t("dashboard.error_000001"),});
        }
      } else {
        this.setState({
          listItems: update(this.state.listItems, {$unshift: [data]})
        });
        this.addFavorite(this.state.listItems[0], this.props.room);
        this.closeFormView();
      }
    };
    SMUserResource.postFavoriteList(this.props.user.username, favoriteListName, responseHandler);
  }

  addFavorite(favoriteList, room) {
    const beforeListedFavoriteCount = room.registered_favorite_lists.length;
    const $messageContainer = $(this.refs.modal);

    let responseHandler = (data, error, xhr)=>{
      if (error) {
        if (xhr.responseJSON.message) {
          $messageContainer.showFailMessage(xhr.responseJSON.message);
        } else {
          $messageContainer.showFailMessage(I18n.t("dashboard.error_000001"));
        }
      }
    };

    SMUserResource.postListedFavorite(this.state.user.username, favoriteList.id, room.id, "Room", responseHandler);

    room.registered_favorite_lists.push(favoriteList.id);
    room.is_favorite = true;
    const afterListedFavoriteCount = room.registered_favorite_lists.length;
    // 初めてお気に入りに登録する場合はルームのお気に入り数を増やす
    if (beforeListedFavoriteCount == 0 && afterListedFavoriteCount == 1) {
      room.favorites_count++;
    }

    this.setState({
      room: room
    });
  }

  removeFavorite(favoriteList, room) {
    const beforeListedFavoriteCount = room.registered_favorite_lists.length;
    const $messageContainer = $(this.refs.modal);

    let responseHandler = (data, error, xhr)=>{
      if (error) {
        if (xhr.responseJSON.message) {
          $messageContainer.showFailMessage(xhr.responseJSON.message);
        } else {
          $messageContainer.showFailMessage(I18n.t("dashboard.error_000001"));
        }
      }
    };

    SMUserResource.deleteListedFavorite(this.state.user.username, favoriteList.id, room.id, "Room", responseHandler);

    let index = room.registered_favorite_lists.indexOf(favoriteList.id);
    room.registered_favorite_lists.splice(index, 1);
    room.is_favorite = room.registered_favorite_lists.length > 0 ? true : false;
    const afterListedFavoriteCount = room.registered_favorite_lists.length;
    // 全てのお気に入りリストからお気に入りを解除した場合
    if (beforeListedFavoriteCount != 0 && afterListedFavoriteCount == 0) {
      room.favorites_count--;
    }

    this.setState({
      room: room
    });
  }

  renderFormItemError() {
    const message = this.state.errorText;
    if (message) {
      return(
        <p className="dashboad-favorite__popup-add-content-error pc-hide__sm-show pb5"><i className="fa fa-exclamation-circle"></i>{message}</p>
      );
    }
    return null;
  }

  renderFormItemErrorSm() {
    const message = this.state.errorText;
    if (message) {
      return(
        <p className="dashboad-favorite__popup-add-content-error sm-hide"><i className="fa fa-exclamation-circle mr3"></i>{message}</p>
      );
    }
    return null;
  }

  renderFavoriteListIndex(room) {
    return(
      <div className="row" ref="mainCol">
        {(()=>{
          let rows = [];
          for (let rowIndex = 0; rowIndex < this.state.listItems.length; rowIndex++) {
            let favoriteList = this.state.listItems[rowIndex];
            let favoriteListImageUrl = "";
            if (favoriteList.thumbnail == 0){
              favoriteListImageUrl = this.props.noFavoriteListImage;
            } else {
              favoriteListImageUrl = SMFormatHelper.favoriteListImageURL(favoriteList, {width: 490, height: 490});
            };
            const id = "dashboad-favorite__checkbox" + favoriteList.id;
            const checked = room.registered_favorite_lists.indexOf(favoriteList.id) != -1;

            rows.push(
              <div key={id} className="col-md-4">
                <div className="dashboad-favorite__popup-select-box">
                  <input type="checkbox" checked={checked} id={id} readOnly={true} className="dashboad-favorite__checkbox" />
                  <label htmlFor={id} className="dashboad-favorite__checkbox" onClick={this.favoriteListImageDidSelect.bind(this, favoriteList, room)}>
                    <div className="dashboad-favorite__popup-select-box-img sm-hide">
                      <img src={favoriteListImageUrl} className="dashboad-favorite__popup-select-box-img-space" alt={favoriteList.name}></img>
                    </div>
                    <div className="dashboad-favorite__popup-select-box-text">
                      <h3 className="dashboad-favorite__popup-select-box-text-title">{favoriteList.name}</h3>
                      <p className="dashboad-favorite__popup-select-box-text-check sm-hide"><i className="fa fa-check"></i></p>
                    </div>
                  </label>
                </div>
              </div>
            );
          }
          return rows;
        })()}
      </div>
    );
  }

  renderCreateFavoriteListView() {
    if(!this.state.isFavoriteListCreateViewOpen) return;
    return(
      <form ref="form" onSubmit={this.formDidSubmit.bind(this)}>
        <div className="dashboad-favorite__popup-add-content">
          <p className="dashboad-favorite__popup-add-content-description">リスト名を入力してください。</p>
          <div className="dashboad-favorite__popup-add-form-area ma">
            <input ref="favoriteListName" type="text" className="popup-form__text popup-form__textarea dashboad-favorite__popup-form-area" placeholder={I18n.t('dashboard.text_000900')} />
            {this.renderFormItemError()}
          </div>
          <div className="dashboad-favorite__popup-add-content-action">
            <input type="submit" name="commit" value="リストの作成" className="button-blue dashboad-favorite__popup-add-content-button" />
            <p className="button-gray dashboad-favorite__popup-add-content-button" onClick={this.closeFormView.bind(this)}>キャンセル</p>
          </div>
          {this.renderFormItemErrorSm()}
        </div>
      </form>
    );
  }

  render() {
    let room = this.props.room;
    const selectFavoriteListStyle = this.state.isFavoriteListCreateViewOpen ? {display: "none"} : {};

    if (Object.keys(room).length === 0 || !this.props.user) {
      return null;
    } else {
      return (
        <div>
          <div className="md-modal md-effect-101" ref="modal">
            <div className="md-content">
              <div className="page__popup dashboad-favorite__popup">
                <p className="page__popup__cancel dashboad-favorite__popup-cancel">
                  <a className="md-close" href="#">
                    <span className="page__popup__cancel-icon dashboad-favorite__popup-cancel-icon">×</span>
                    <span className="dashboad-favorite__popup-cancel-text">閉じる</span>
                  </a>
                </p>
                <div className="popup-headline">
                  <h1 className="popup-headline__title">リストの選択</h1>
                  <p className="dashboad-favorite__popup-headline-text">保存するリストを選択してください。<br />複数選択できます。</p>
                </div>
                <p style={selectFavoriteListStyle} className="dashboad-favorite__popup-add"><a href="#" onClick={this.showFormView.bind(this)}><i className="fa fa-plus mr5"></i>新規リスト作成</a></p>
                {this.renderCreateFavoriteListView()}
                <div ref="mainCol" className="dashboad-favorite__popup-select">
                  <div className="container dashboad-favorite__popup-select-content">
                    {this.renderFavoriteListIndex(room)}
                  </div>
                </div>
                <p className="dashboad-favorite__popup-select-caution">今後のお気に入りは最後に選択したリストに追加されます。</p>
                <p className="button-blue dashboad-favorite__popup-content-button md-close"
                   onClick={this.dismiss.bind(this)}>閉じる</p>
              </div>
            </div>
          </div>
          <div className="md-overlay"></div>
        </div>
      );
    }
  }
}

SMUFavoriteListSelectView.propTypes = {
  user: PropTypes.object.isRequired
};
export default SMUFavoriteListSelectView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/SMUFavoriteListSelectView.jsx